// Weather — Phase 3. Current on-site conditions, 10-day forecast, spray
// windows, and frost/freeze alerts. Pure composition over existing cards.

import { useParams } from 'react-router-dom';
import { PageHeader } from '../components/ui/page-header';
import { OnSiteStationCard } from '../components/OnSiteStationCard.js';
import { ForecastWidget } from '../components/ForecastWidget.js';
import { SprayWindowCard } from '../components/SprayWindowCard.js';
import { WeatherAlertsInbox } from '../components/WeatherAlertsInbox.js';

export function WeatherPage() {
  const { courseSlug } = useParams();
  if (!courseSlug) return null;
  return (
    <div className="mx-auto max-w-7xl p-6 md:p-10">
      <PageHeader
        eyebrow="Phase 3"
        title="Weather"
        description="On-site station, 10-day forecast, spray windows, and frost / hard-freeze alerts."
      />

      {/* On-site station + weather alerts on top row; forecast goes full-width
          below so the 10-day strip gets enough horizontal room for each tile.
          Spray windows also spans full width — the windowing table benefits
          from wider columns. */}
      <div className="mt-8 grid gap-4 lg:grid-cols-2 [&_section]:!mt-0">
        <OnSiteStationCard courseSlug={courseSlug} />
        <WeatherAlertsInbox courseSlug={courseSlug} />
      </div>
      <div className="mt-4 [&_section]:!mt-0">
        <ForecastWidget courseSlug={courseSlug} />
      </div>
      <div className="mt-4 [&_section]:!mt-0">
        <SprayWindowCard courseSlug={courseSlug} />
      </div>
    </div>
  );
}
